import React, {useEffect, useState} from "react";
import {Input, PageHeader} from "../../components";
import StepWizard from "react-step-wizard";
import {Chip, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Papa from "papaparse";
import {supabase} from "../../services/supabase.service";
import Textarea from "../../components/Textarea";
import "./styles.css";

const Contest = () => {
    const [loading, setLoading] = useState(true);
    const [contest, setContest] = useState<any>(false);
    const [data, setData] = useState<any[]>([]);
    const [file, setFile] = useState<any>();

    useEffect(() => {
        (async ()=>{
            await getContestId()
        })();
    }, [])

    function setContestData(e: any) {
        const {name, value} = e.target;
        setContest({...contest, [name.trim()]: value.trim()});
    }

    function downloadModel(model: string) {
        window.open(`https://idxasdyjtohttzhbdmnq.supabase.co/storage/v1/object/public/demo//modelo_${model.toLowerCase()}.csv`, '_blank');
    }

    async function getContestId() {
        const {data}:any = await supabase.from('editions').select('id, edition_number')
            .order('id', {ascending: false}).limit(1)
        if (data && data.length) {
            const edition_number = parseInt(data[0]?.edition_number);
            await getContestCriteria(edition_number)
        }
    }

    async function getContestCriteria(edition_number: number) {
        const { data:edition_criteria } = await supabase.from('edition_criteria').select('*')
            .eq('edition', edition_number)
            .order('id', { ascending: true });
        if (edition_criteria && edition_criteria.length) {
            setContest({...contest, edition_criteria, edition_number});
            setLoading(false);
        }
    }

    function resetData(type:string) {
        setData([]);
        setContest({...contest, [type]: []})
        setFile(null);
    }

    return (
        <div id="page-teacher-form" className="container">
            <PageHeader
                title="Nova Avaliação"
                description={`Siga os passos abaixo para criar um novo formulário de avaliação.`}
            />
            <main>
                {loading && (
                    <fieldset>
                        <legend>Aguarde...</legend>
                    </fieldset>
                )}
                {!loading && contest && (
                    <form>
                        <fieldset>
                            <StepWizard isLazyMount={true}>
                                <StepBasic/>
                                <StepCriteria/>
                                <StepData type="evaluators"/>
                                <StepData type="candidates"/>
                                <StepResults/>
                            </StepWizard>
                        </fieldset>

                    </form>
                )}
            </main>
        </div>
    )

    //TODO: Criar um componente para cada step
    function StepResults() {
        const [message, setMessage] = useState('');
        const [loading, setLoading] = useState(true);
        const [url, setUrl] = useState('https://www.avaliar.plataformaasta.com.br/contest');

        function copyToClipboard() {
            navigator.clipboard.writeText(url);
        }

        useEffect(() => {
            let mounted = true;
            (async() => {
                if (mounted) {
                    setLoading(true);
                    setMessage("Gerando novo concurso, aguarde...");

                    try {
                        await supabase.from('editions').insert([{
                            edition_number: contest.edition_number,
                            title: contest.title,
                            description: contest.description
                        }]);

                        let finalCriteria = contest.edition_criteria.map((e: any) => {
                            return {
                                title: e.title.trim(),
                                description: e.description.trim(),
                                maximum: 5,
                                edition: parseInt(contest.edition_number)
                            }
                        })

                        await supabase.from('edition_criteria').insert(finalCriteria);
                        const evaluators = contest.evaluators
                            .map((e: any) => {
                                return {
                                    name: e.nome.trim(),
                                    email: e.email.trim(),
                                    grupo: parseInt(e.grupo),
                                    edicao: parseInt(contest.edition_number)
                                }
                            });

                        const candidates = contest.candidates
                            .map((e: any) => {
                                const format = (e.formato.toLowerCase() === 'texto') ? 'text' : 'video';
                                return {
                                    name: e.nome.trim(), email: e.email.trim(), group_id: parseInt(e.grupo),
                                    text: (format === 'text') ? e.texto_video.trim() : '',
                                    video: (format === 'video') ? e.texto_video.trim() : '',
                                    edicao: parseInt(contest.edition_number), format
                                }
                            });
                        // new promisse chain

                        await supabase.from('evaluators').insert(evaluators);
                        await supabase.from('eval_students').insert(candidates);

                        setMessage("Concurso gerado com sucesso.");

                        setUrl(`${window.location.origin}/concurso/${contest.edition_number}/${contest.title.toLowerCase().replace(/ /g, '-')}`);
                        setLoading(false);

                    } catch (e) {
                        console.log("erro")
                        setLoading(false);
                        setMessage("Falha ao gerar concurso. Tente novamente. 😕");
                        setUrl('');
                        console.log(e);
                    }
                }
                //resetData('evaluators');
                //resetData('candidates');
            })();

        }, [])

        return (
            <Grid container justifyContent="flex-start" spacing={3}>
                {!loading && (
                <>
                    <Grid item xs={12}>
                        {message && (
                            <fieldset>
                                <legend>{message}</legend>
                            </fieldset>
                        )}
                    </Grid>
                    {url && (
                        <>
                            <Grid item md={8} lg={8} xs={12}>
                                <Chip label={url} size="medium" style={{fontSize:'15px'}}  />
                            </Grid>
                            <Grid item md={2} lg={2} xs={6}>
                                <button type="button" onClick={copyToClipboard}>Copiar</button>
                            </Grid>
                            <Grid item md={2} lg={2} xs={6}>
                                <button type="button" onClick={()=>{window.open(url,'_blank')}}>Abrir</button>
                            </Grid>
                            <Grid item xs={12}>
                                <Chip label={url.replace('concurso', 'dashboard')} size="medium" style={{fontSize:'15px'}}  />
                            </Grid>
                        </>
                    )}
                </>
                )}
            </Grid>
        )
    }

    function StepBasic({...props}) {

        function validateBasicInfo() {
            if (contest.title && contest.description) {
                props.nextStep();
            } else {
                alert("Preencha todos os campos para continuar");
            }
        }

        return (
            <>
                {data.length === 0 &&  (
                    <legend>Informe os dados do concurso:</legend>
                )}
                <Grid container justifyContent="flex-end" spacing={3}>
                    <Grid item xs={12}>
                        <Input
                            name="title"
                            label="Título"
                            placeholder="Título do concurso:"
                            defaultValue={contest.title}
                            onBlur={setContestData}
                        />
                        <Input
                            name="description"
                            label="Descrição"
                            placeholder="Descrição do concurso:"
                            defaultValue={contest.description}
                            onBlur={setContestData}
                        />
                    </Grid>

                    <Grid item xs={12} alignContent="flex-end" alignItems="flex-end">
                        <button type="button" onClick={validateBasicInfo}>Prosseguir</button>
                    </Grid>
                </Grid>
            </>
        )
    }

    function StepCriteria({...props}) {
        const [criteria, setCriteria] = useState<any[]>(contest.edition_criteria || []);
        const [newCriteria, setNewCriteria] = useState({ title: '', description: '' });

        function addCriteria() {
            if (newCriteria.title && newCriteria.description ) {
                setCriteria([...criteria, newCriteria]);
                setNewCriteria({ title: '', description: '' });
            } else {
                alert("Preencha todos os campos para continuar");
            }
        }

        function removeCriteria(index: number) {
            const newCriteria = criteria.filter((_, i) => i !== index);
            setCriteria(newCriteria);
        }

        function validateCriteria() {
            if (criteria.length > 0) {
                setContest({ ...contest, edition_criteria: criteria })
                props.nextStep();
            } else {
                alert("Preencha todos os campos para continuar");
            }
        }

        return (
            <>
                <legend>Informe os critérios do concurso:</legend>
                <Grid container justifyContent="flex-end" >
                        <Grid  item container justifyContent="flex-start" spacing={3}>
                            <Grid item xs={12} >
                                <Input name="title" label="Título" placeholder="Título do critério"
                                    defaultValue={newCriteria.title}
                                    onBlur={(e)=>setNewCriteria({...newCriteria, title: e.target.value})}
                                ></Input>
                                <Textarea
                                    style={{ minHeight: '50px' }}
                                    name="criteria"
                                    label="Critério"
                                    rows={2}
                                    placeholder="Descrição do Critério:"
                                    defaultValue={newCriteria.description}
                                    onBlur={(e)=>setNewCriteria({...newCriteria, description: e.target.value})}
                                />
                            </Grid>

                            <Grid container item xs={2} alignItems="flex-end" alignContent="flex-end" >
                                <button type="button" onClick={addCriteria}>+ Critério</button>
                            </Grid>
                    </Grid>
                    <Grid container item xs={12} className="criteria-list">
                            {criteria.map((c, i) => (
                                <Grid container key={i}  className="criteria-item" onDrag={()=>{console.log("drag")}}>
                                    <Grid item xs={12} lg={10} md={10} >
                                        <b className="criteria-name">{i+1} - {c.title}</b><br/><span className="criteria-descrition">{c.description}</span>
                                    </Grid>
                                    <Grid container alignContent="center" item xs={12} lg={2} md={2}>
                                        <button type="button" onClick={() => removeCriteria(i)}>Excluir</button>
                                    </Grid>
                                </Grid>
                            ))}
                    </Grid>
                    <Grid style={{marginTop:'20px'}} item xs={2}>
                        <button type="button" onClick={validateCriteria}>Prosseguir</button>
                    </Grid>
                </Grid>
            </>
        )
    }

    function StepData({...props}) {
        const [message, setMessage] = useState('');
        const allowedExtensions = ["csv"];

        const handleFileChange = (e: any) => {
            setMessage("Carregando arquivo...")
            if (e.target.files.length) {
                const inputFile = e.target.files[0];
                const fileExtension = inputFile?.type.split("/")[1];
                if (!allowedExtensions.includes(fileExtension)) {
                    alert("Por favor envie um arquivo no formato .csv");
                    return;
                }
                setMessage("")
                setFile(inputFile);
            }
        }

        const handleParse = () => {
            if (!file) return alert("Envie um arquivo válido");
            const reader = new FileReader();

            reader.onload = async (e: any) => {
                if (!e?.target) return;
                const csv = Papa.parse(e?.target?.result, {header: true, skipEmptyLines: true, delimitersToGuess: [',', ';']});
                const parsedData = csv?.data.filter((e: any) => (e.nome !== '' && e.email !== '' && e.grupo !== ''));
                setData(parsedData);
            };
            reader.readAsText(file, "UTF-8");
        }

        function saveData() {
            if (data.length === 0) return alert("Envie um arquivo válido");

            let defaultColumns = ['nome', 'email', 'grupo'];

            if (props.type === "candidates")
                defaultColumns = ['grupo', 'nome', 'email', 'formato', 'texto_video'];

            if (JSON.stringify(Object.keys(data[0])) !== JSON.stringify(defaultColumns))
                return alert(`Confira os colunas do arquivo enviado`);

            setContest({...contest, [props.type]: data})

            setData([]);
            setFile(null);

            props.nextStep();
        }

        const title = props.type === 'evaluators' ? "Avaliadores" : "Candidatos";

        return (
            <Grid container justifyContent="flex-end" alignItems="flex-end" spacing={3}>
                {message && (
                    <fieldset>
                        <legend>{message}</legend>
                    </fieldset>
                )}
                {data.length === 0 &&  (
                    <legend>Informe os {title} do concurso:</legend>
                )}
                {(data.length === 0) && (
                    <>
                        <Grid item xs={7}>
                            <p>Envie o arquivo .csv de acordo com o modelo.</p>
                            <div className="form-control">
                                {!file && <Input
                                    type="file"
                                    onChange={handleFileChange}
                                    name="evaluators"
                                    label={'Arquivo .csv'}
                                    style={{paddingTop: '15px'}}
                                /> }
                                {file && <h5>{file.name}</h5>}
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className="form-control" style={{paddingBottom: '10px'}}>
                                <button type="button" disabled={(!file)} onClick={handleParse}>Enviar arquivo</button>
                            </div>
                        </Grid>
                        <Grid item xs={2}>
                            <div className="form-control" style={{paddingBottom: '10px'}}>
                                <button type="button" className="btn-default"
                                        onClick={() => downloadModel(title)}>Baixar Modelo
                                </button>
                            </div>
                        </Grid>
                    </>
                )}
                {data && data.length > 0 && (
                    <Grid item xs={12}>
                        <h4>Prévia:</h4>
                        <Paper variant="outlined" style={{marginTop: '5px', marginBottom: '5px'}}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        {Object.keys(data[0]).map((key, index) => {
                                            if (key.toLowerCase() !== 'cpf') {
                                                return <TableCell key={index}
                                                                  style={{textTransform: 'capitalize'}}>{key}</TableCell>
                                            }
                                            return;
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[...data].splice(0, 5).map((row, i) => (
                                        <TableRow key={Math.random()}>
                                            {Object.values(row).map((value: any, index) => (
                                                <TableCell key={index}>{value.substring(0, 100)}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}

                                </TableBody>
                            </Table>
                        </Paper>
                        <h5>Número de Inscritos: {data.length} </h5>
                        <Grid item xs={12}>
                            <div className="form-control" style={{paddingBottom: '10px'}}>
                                <button className="btn-default" onClick={()=>resetData(props.type)}>Cancelar envio</button>
                            </div>
                        </Grid>
                    </Grid>
                )}
                <Grid item xs={2}>
                    {!loading && data.length > 0 &&
                        <button type="button" onClick={saveData}>Prosseguir</button>
                    }
                </Grid>
            </Grid>
        )
    }
}
export default Contest;
